<script setup lang="ts">
import Vapor from 'laravel-vapor'

defineProps({
  achievement: Object,
})
</script>

<template>
  <div class="flex flex-col items-center justify-between text-center">
    <div class="relative flex size-full items-center justify-center">
      <img
        :src="Vapor.asset(achievement.image)"
        draggable="false"
        :class="{
          'pointer-events-none select-none brightness-100 contrast-0':
            !achievement.pivot ||
            (achievement.pivot.progress !== null && achievement.pivot.progress < 100),
        }"
        class="size-24"
        :alt="achievement.name"
      />
      <div
        v-if="
          !achievement.pivot ||
          (achievement.pivot.progress !== null && achievement.pivot.progress < 100)
        "
        class="absolute -mt-4 text-[2.5rem] text-white"
      >
        ?
      </div>
    </div>
    <h3 class="font-semibold">{{ achievement.name }}</h3>
    <p class="text-sm text-gray-500">{{ achievement.description }}</p>

    <div v-if="achievement.pivot && achievement.pivot.progress > 0" class="mt-2 w-full">
      <div class="relative h-2 w-full rounded-full bg-gray-200">
        <div
          class="absolute left-0 top-0 h-2 rounded-full bg-blue-500"
          :style="{ width: achievement.pivot.progress + '%' }"
        ></div>
      </div>
      <p class="mt-1 text-xs text-gray-500">{{ achievement.pivot.progress }}% Complete</p>
    </div>
  </div>
</template>
